import * as React from "react";
import PropTypes from 'prop-types';

const SvgMobileFill = props => {
  if (props.id !== "_svgmobilefill") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 240 240" {...props}><path fill="#333" d="M180.584-.233L59 0c-8.714 0-15 6.956-15 16v208c0 9.043 6.286 16 15 16l121.584.233c8.715 0 15.416-7.19 15.416-16.233V16c0-9.044-6.701-16.233-15.416-16.233zM120 220a8 8 0 110-16 8 8 0 010 16zm48-35c0 5.425-5.248 11-11 11H82c-5.608 0-9.93-4.831-9.93-10.439L72 38c-.274-2.406.387-5.174 2-7 1.862-2.108 5-3 8-3h76c4.751 0 10 4.116 10 10v147z" /></svg>;
};

SvgMobileFill.displayName = "_svgmobilefill";
SvgMobileFill.propTypes = {
  id: PropTypes.string
};
SvgMobileFill.defaultProps = {
  id: ''
};
export default SvgMobileFill;